import { miraimindsAPI } from '../../axios'
import { getMessageFromError } from '../utils/functions'

export default {
  async aiVyakhyaTextGenerate({ commit }, { input, lang }) {

    commit('SET_STATE', {
      action: 'createLoading',
      data: true
    })
    try {

      const res = await miraimindsAPI.post(`/generate/vyakhya-text?lang=${lang}`, {
        input
      });
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'aiVyakhyaTextGenerateData',
        data: res.data.message
      })
      return {
        data: res.data.message,
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  async aiVyakhyaAudioGenerate({ commit }, { input, lang }) {

    commit('SET_STATE', {
      action: 'audioGenerateLoading',
      data: true
    })
    try {

      const res = await miraimindsAPI.post(`/generate/vyakhya-audio?lang=${lang}`, {
        input
      }, {
        responseType: 'blob'
      });
      commit('SET_STATE', {
        action: 'audioGenerateLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'aiVyakhyaTextGenerateData',
        data: res.data
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'audioGenerateLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

}
